import { supportsPassive, isMobile } from '@/utils/features';

export default function(dom, opts) {
	let options = {
		baseClass: 'howtosteam',
		colors: ['yellow', 'blue', 'purple','rose'],
		...opts
	};

	let thresholdTop = 0.15;

	const video = dom.querySelector(`.${options.baseClass}__video-element`);
	const texts = Array.from(dom.querySelectorAll(`.${options.baseClass}__text`));
	let currentText;
  let playing;

  const checkTime = () => {
    if (video.currentTime >= currentText.dataset.goto) {
			video.pause();
			video.currentTime = currentText.dataset.goto;
		}
		else {
			requestIdleCallback(checkTime);
		}
  }

	const updateVideoPosition = () => {
		currentText = texts[0];

		for (let text of texts) {
			const rect = text.getBoundingClientRect();

			if (rect.top <= (window.innerHeight * thresholdTop)) {
				currentText = text;
			}
		}

		const index = texts.indexOf(currentText);

		if (playing != index) {
			video.currentTime = currentText.dataset.start;
			try {
				video.play();
			}
			catch(err) {

			}
			checkTime();

			options.colors.forEach(color => dom.classList.remove(`${options.baseClass}--bg-${color}`));
			dom.classList.add(`${options.baseClass}--bg-${options.colors[index]}`);
			playing = index;
		}
	};

	window.addEventListener('scroll', updateVideoPosition, supportsPassive ? {passive: false} : null);
	updateVideoPosition();
}
